import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PageHero from "@/components/PageHero";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

const API_ROOT = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PlayersPage() {
  const [players, setPlayers] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/players").then((r) => setPlayers(r.data)); }, []);

  const filtered = players.filter((p) =>
    p.name.toLowerCase().includes(q.toLowerCase()) ||
    (p.district || "").toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div data-testid="players-page">
      <PageHero
        eyebrow="Player directory"
        title="PLAYERS"
        subtitle="Meet the athletes competing across Jharkhand."
        image="https://images.unsplash.com/photo-1595435742656-5272d0b3fa82?w=1800"
      />
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-14">
        <div className="relative max-w-md mb-8">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-jpa-muted" />
          <Input
            data-testid="players-search"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search players or districts..."
            className="pl-9 rounded-sm border-jpa-border"
          />
        </div>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-5">
          {filtered.map((p) => (
            <Link key={p.id} to={`/players/${p.id}`} data-testid={`player-card-${p.id}`} className="group block relative overflow-hidden border border-jpa-border">
              <div className="aspect-[3/4] bg-jpa-surface overflow-hidden flex items-center justify-center">
                {p.jpa_id ? (
                  <img
                    src={`${API_ROOT}/players/by-jpa/${p.jpa_id}/photo`}
                    alt={p.name}
                    loading="lazy"
                    decoding="async"
                    onError={(e) => {
                      e.currentTarget.style.display = "none";
                      const s = e.currentTarget.parentElement.querySelector("[data-photo-pending]");
                      if (s) s.style.display = "block";
                    }}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                ) : null}
                <div data-photo-pending style={{ display: p.jpa_id ? "none" : "block" }} className="text-center px-3">
                  <div className="font-display text-lg tracking-wider text-jpa-muted">PHOTO</div>
                  <div className="font-display text-lg tracking-wider text-jpa-muted">PENDING</div>
                </div>
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-jpa-ink via-jpa-ink/20 to-transparent pointer-events-none" />
              <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
                <div className="flex items-center gap-2 mb-1">
                  <span className="bg-jpa-accent text-jpa-ink px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest skew-badge">
                    Rank #{p.ranking || "—"}
                  </span>
                  <span className="text-[10px] uppercase tracking-widest text-white/80">{p.gender === "M" ? "Men's" : "Women's"}</span>
                </div>
                <div className="font-display text-2xl tracking-wider">{p.name}</div>
                <div className="text-xs uppercase tracking-widest text-white/80">{p.district}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

